var React = require('react');

function ResourceMediumPodcastInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3.31484","y":"0.6","width":"5.65714","height":"10.2286","rx":"2.82857","stroke":"#717171","strokeWidth":"1.2","key":0}),React.createElement("path",{"d":"M6.14258 13.7148L6.14258 16.0006","stroke":"#717171","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M3.85742 16H8.42885","stroke":"#717171","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M1 8C1 9.71429 2.48571 13.1429 6.14286 13.1429C9.8 13.1429 11.2857 9.71429 11.2857 8","stroke":"#717171","strokeWidth":"1.2","strokeLinecap":"round","key":3})]);
}

ResourceMediumPodcastInline.defaultProps = {"width":"12","height":"17","viewBox":"0 0 12 17","fill":"none"};

module.exports = ResourceMediumPodcastInline;

ResourceMediumPodcastInline.default = ResourceMediumPodcastInline;
